import * as React from 'react';
import {Gallery, Item} from 'react-photoswipe-gallery'
import 'photoswipe/dist/photoswipe.css'
import System from "../helper/system";

export function ImageGallery(props) {
    const {single_image_url,sliderImage} = props;
    return (
        <Gallery>
            <div onClick={() => {
                System.popup('ProductImagePopup', {list: sliderImage,selected:single_image_url})
            }}>{props.children}</div>
        </Gallery>
    );
}


export default ImageGallery;